import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Visit `}<a parentName="p" {...{
        "href": "https://www.lekoarts.de?utm_source=cara&utm_medium=Starter"
      }}>{`my website`}</a>{` or find me on other platforms: `}<a parentName="p" {...{
        "href": "https://www.twitter.com/lekoarts_de"
      }}>{`Twitter`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/lennart-joergens/"
      }}>{`LinkedIn`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      